<template>
  <div
    class="tabs-button-group"
  >
    <div
      class="tabs-button"
      v-for="(targetComponent, index) in componentTypes"
      :key="index"
    >
      <button
      class="btn"
      @click="handleTabSwitch(index)"
      :class="{ active: index === tabs, request: targetComponent.isRequest }"
      >
        <span>
          {{ targetComponent.pageTitle }}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  props: {
    componentTypes: {
      type: Array,
      required: true,
    },
    tabs: {
      type: Number,
      required: true,
    },

  },
  methods: {
    handleTabSwitch(index) {
      this.$emit('input-emit', index)
    }

  }
}
</script>

<style lang="scss" scoped>
.tabs {
  &-button {
    position: relative;
    &-group {
      margin: 0 auto 10px;
    }
    .btn {
      &.request {
        span {
          position: relative;
          &::before {
            position: absolute;
            content: '!';
            width: 20px;
            height: 20px;
            top: -2px;
            left: -30px;
            background: $news_color;
            color: #fff;
            border-radius: 20px;
            font-weight: 500;
            text-align: center;
          }
        }
      }
    }
  }
}
::v-deep .tabs {
  &-button {
    width: calc(100% / 2);
  }
}
</style>
